import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-inv-cond',
  templateUrl: './inv-cond.component.html',
  styleUrls: ['./inv-cond.component.css']
})
export class InvCondComponent implements OnInit {

  model = {
    'table_name': 'inv_cond', 'inv_cond_id': '0', 'cond_list_id': '', 'cond_desc': '', 'cond_desc_en': '',
    'cond_seq': '', 'comment': ''
  };
  seq = [];

  Success_Msg; Error_Msg; Term_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<InvCondComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Term_Msg').subscribe((res: string) => {
      this.Term_Msg = res;
    });

  }


  ngOnInit() {
    for (let index = 1; index <= 100; index++) {
      this.seq[index] = index;

    }

    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['cond_desc'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['inv_cond_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'inv_cond_id': this.model['inv_cond_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['cond_desc'] == '') {
      alert(this.Term_Msg);
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
